import HBPageTitle from "@/components/HBPageTitle";
import HBSelect from "@/components/HBSelect";
import { UserGuideTooltip } from "@/components/UserGuideTooltip";
import constantFactory from "@gaoding/constant-factory";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import { Case, Default, Switch } from "react-if";
import styles from "../../index.module.less";
import TabPanel from "../TabPanel";
import MyFavoriteBoardList from "./MyFavoriteBoardList";
import MyFavoritePinList from "./MyFavoritePinList";
import MyFavoriteTopicList from "./MyFavouriteTopicList";

const CATEGORY = {
  PIN: "pins",
  BOARD: "boards",
  TOPIC: "topics",
};

export default function MyFavorite({
  user,
  initLikesPins,
  initLikesBoards,
  initLikesTopics,
  isMe,
}) {
  const router = useRouter();
  const { tagName: category = CATEGORY.PIN, urlname } = router.query;

  const onCategoryChange = useCallback(
    (option) => {
      const { value } = option || {};
      router.replace(
        `/user/${urlname}/likes/${value === CATEGORY.PIN ? "" : value}`
      );
    },
    [router, urlname]
  );

  const hasBoardLikes = useMemo(() => {
    return user?.boards_like_count > 0;
  }, [user?.boards_like_count]);

  const hasTopicLikes = useMemo(() => {
    return user?.topic_like_count > 0;
  }, [user?.topic_like_count]);

  const { LIKES_LIST, LIKES_ITEM_MAP } = useMemo(() => {
    return constantFactory("LIKES", [
      {
        key: CATEGORY.PIN,
        label: "采集",
        value: CATEGORY.PIN,
      },
      ...(hasBoardLikes
        ? [
            {
              key: CATEGORY.BOARD,
              label: "画板",
              value: CATEGORY.BOARD,
            },
          ]
        : []),
      ...(hasTopicLikes
        ? [
            {
              key: CATEGORY.TOPIC,
              label: "主题",
              value: CATEGORY.TOPIC,
            },
          ]
        : []),
    ]);
  }, [hasBoardLikes, hasTopicLikes]);

  const backAction = useCallback(() => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push("/user/" + urlname);
    }
  }, [router, urlname]);

  return (
    <>
      <HBPageTitle
        title={`${isMe ? "我" : user?.username}的喜欢`}
        backAction={backAction}
        actions={
          hasBoardLikes || hasTopicLikes ? (
            <UserGuideTooltip
              title="点击这里可切换采集"
              placement="left"
              localStorageKey="user_page_guide_8"
            >
              <HBSelect
                className={styles.sort}
                allowClear={false}
                options={LIKES_LIST}
                value={LIKES_ITEM_MAP[category]}
                onChange={onCategoryChange}
              />
            </UserGuideTooltip>
          ) : null
        }
      />

      <TabPanel>
        <div style={{ marginTop: "16px" }}>
          <Switch>
            {/* 画板 */}
            <Case condition={category === CATEGORY.BOARD}>
              <MyFavoriteBoardList
                initLikesBoards={initLikesBoards}
                user={user}
              />
            </Case>

            {/* 主题 */}
            <Case condition={category === CATEGORY.TOPIC}>
              <MyFavoriteTopicList
                user={user}
                initLikesTopics={initLikesTopics}
              />
            </Case>

            {/* 灵感 */}
            <Default>
              <MyFavoritePinList initLikesPins={initLikesPins} user={user} />
            </Default>
          </Switch>
        </div>
      </TabPanel>
    </>
  );
}
